import { createContext, useContext, useMemo } from "react";
import useSettingsQuery from "../hooks/useSettingsQuery";

const SettingsContext = createContext({ settings: null, isLoading: true });

export default function SettingsProvider({ children }) {
    const { data, isLoading } = useSettingsQuery();
    const value = useMemo(
        () => ({ settings: data ?? null, isLoading }),
        [data, isLoading]
    );
    return (
        <SettingsContext.Provider value={value}>
            {children}
        </SettingsContext.Provider>
    );
}

export function useSettings() {
    return useContext(SettingsContext);
}
